<div class="action-container d-flex flex-wrap justify-content-between">
    <div class="action-buttons d-flex justify-content-between w-100">
        <button
            type="button"
            *ngIf="showPreviewMode"
            [disabled]="isDisabled"
            class="btn btn-primary me-3"
            data-uit="add-files-button"
            (click)="handleAddFiles()"
        >
            <ca-icon name="plus" size="s"></ca-icon>
            {{ 'WORKFLOWS.RUNNER.ADD_FILES' | translate }}
        </button>
        <button type="button" [disabled]="isDisabled" class="btn btn-secondary" data-uit="reset-workflow-starter" (click)="resetFiles()">
            {{ 'WORKFLOWS.RUNNER.RESET' | translate }}
        </button>
        <button
            type="button"
            *ngIf="showViewAllButton && !showPreviewMode"
            [disabled]="isDisabled"
            class="btn btn-primary ms-3"
            (click)="viewSelection()"
            data-uit="file-selection-view-all-btn"
        >
            {{ 'WORKFLOWS.RUNNER.VIEW' | translate }}
        </button>
    </div>
</div>
<div class="selection-container overflow-hidden h-100" data-uit="selected-files-list">
    <ca-list-shell
        class="h-100"
        (onTriggerSearchAndSort)="onFileSearchOrSort($event)"
        [searchAndSortOptions]="searchAndSortOptions"
        [totalItemsCount]="filteredSelectedFiles.length"
        [showCategoryButton]="false"
        [showFilterCheckBoxes]="false"
        [sortOptions]="sortOptions"
        [pageSize]="defaultPageSize"
        [updateParameterQuery]="false"
        [useFirstSortOptionAsDefault]="false"
    >
        <div class="d-flex align-items-center selected-files-container">
            <div class="d-flex flex-column">
                <div class="selected-files d-flex justify-content-start align-items-center text-center">
                    <span
                        class="badge d-flex align-items-center justify-content-center overflow-hidden text-nowrap me-2 font-s"
                        data-uit="file-selection-selected-files-length"
                    >
                        {{ selectedFiles.length }}
                    </span>
                    <span>{{
                        selectedFiles.length > 1 || selectedFiles.length === 0
                            ? ('WORKFLOWS.RUNNER.SELECTED_FILES' | translate)
                            : ('WORKFLOWS.RUNNER.SELECTED_FILE' | translate)
                    }}</span>
                    <button
                        *ngIf="!isDisabled && selectedFiles.length > 0 && !showPreviewMode"
                        type="button"
                        class="btn ca-btn-icon clear-btn"
                        (click)="removeAll()"
                        [title]="'WORKFLOWS.RUNNER.CLEAR_SELECTION' | translate"
                    >
                        <ca-icon name="cross" size="l"></ca-icon>
                    </button>
                </div>
            </div>
        </div>
        <div data-uit="selected-items-wrapper" class="selected-items-wrapper px-0">
            <ca-file-selection-item
                *ngFor="let file of pagedSelectedFiles; let i = index; let first = first"
                [class.first]="first"
                [file]="file"
                [isDisabled]="isDisabled"
                [showViewIcon]="showViewIconForSelectedItems"
                [showFileSize]="showFileSize"
                [filesSelectable]="filesSelectable"
                [selected]="selectedIndex != null && file.token === pagedSelectedFiles[selectedIndex].token"
                (onRemoveSelection)="remove(file)"
                (click)="handleFileClick(i)"
                (onEditUrl)="onUpdateFileUrl.emit($event)"
            ></ca-file-selection-item>
        </div>
    </ca-list-shell>
</div>
